import React from 'react';
import { Text, View } from '@react-pdf/renderer';

import { PDF_BLOCK_HEADING, PDF_BLOCK_TEXT, PDF_GRAY } from '../../../../constants';

const PdfTextBlock = ({
    fontNormal,
    fontSmaller,
    disableRightBorder,
    disableBottomBorder,
    disableLeftBorder,
    disableTopBorder,
    text,
    title,
    hideHeading,
    hideText = false,
    titleStyles = {},
    textStyles = {}
}) => {
    return (
        <View
            style={{
                flexGrow: hideText ? "0" : "1",
                flexDirection: "column",
                width: "100%",
                borderWidth: "1px",
                borderColor: "#000",
                borderRightWidth: disableRightBorder ? "0" : "1px",
                borderLeftWidth: disableLeftBorder ? "0" : "1px",
                borderTopWidth: disableTopBorder ? "0" : "1px",
                borderBottomWidth: disableBottomBorder ? "0" : "1px",
            }}
        >
            {
                !hideHeading &&
                <View
                    style={{
                        flexShrink: 0,
                        borderBottomWidth: "1px",
                        borderColor: "#000",
                        width: "100%",
                        backgroundColor: PDF_GRAY,
                        padding: "3px 3px"
                    }}
                >
                    <Text style={{
                        fontStyle: "italic",
                        fontSize: PDF_BLOCK_HEADING,
                        fontWeight: "400",
                        ...titleStyles
                    }}>
                        {title ? title : "-"}
                    </Text>
                </View>
            }
            {
                !hideText &&
                <View
                    style={{
                        flexGrow: 1,
                        justifyContent: "center",
                        aligItems: "center",
                        maxWidth: "100%",
                        width: "100%",
                        padding: "5px 5px",
                        textAlign: "left",
                        backgroundColor: "#fff"
                    }}
                >
                    <Text style={{
                        fontSize: fontSmaller ? "8px" : PDF_BLOCK_HEADING,
                        fontWeight: fontNormal ? "400" : "700",
                        ...textStyles
                    }}>
                        {text ? text : "-"}
                    </Text>
                </View>
            }

        </View>
    )
}

export default PdfTextBlock